import * as firebase from 'firebase'

export default {
  state: {
    loadedInvestigators: [
      {
        investigatorId: 'tri',
        investigatorName: 'Investigator Sample',
        investigatorPhone: '123-123-1234',
        investigatorEmail: 'test@test.com'
      }
    ]
  },
  mutations: {
    setLoadedInvestigators (state, payload) {
      state.loadedInvestigators = payload
    },
    createInvestigator (state, payload) {
      state.loadedInvestigators.push(payload)
    },
    updateInvestigator (state, payload) {
      const investigator = state.loadedInvestigators.find(investigator => {
        return investigator.investigatorId === payload.investigatorId
      })
      if (payload.investigatorName) {
        investigator.investigatorName = payload.investigatorName
      }
      if (payload.investigatorPhone) {
        investigator.investigatorPhone = payload.investigatorPhone
      }
      if (payload.investigatorEmail) {
        investigator.investigatorEmail = payload.investigatorEmail
      }
    },
    deleteInvestigator (state, payload) {
      const investigator = state.loadedInvestigators.find(function (investigator) {
        return investigator.investigatorId === payload.investigatorId
      })
      var todos = state.loadedInvestigators
      todos.splice(todos.indexOf(investigator), 1)
    }
  },
  actions: {
    loadInvestigators ({commit}) {
      commit('setLoading', true)
      firebase.database().ref('investigators').once('value')
        .then((data) => {
          const investigators = []
          const obj = data.val()
          for (let key in obj) {
            investigators.push({
              investigatorId: key,
              investigatorName: obj[key].investigatorName,
              investigatorPhone: obj[key].investigatorPhone,
              investigatorEmail: obj[key].investigatorEmail,
              creatorId: obj[key].creatorId
            })
          }
          console.log(investigators)
          commit('setLoadedInvestigators', investigators)
          commit('setLoading', false)
        })
        .catch(
          (error) => {
            console.log(error)
            commit('setLoading', true)
          }
        )
    },
    createInvestigator ({commit, getters}, payload) {
      const investigator = {
        investigatorName: payload.title,
        investigatorPhone: payload.investigatorPhone,
        investigatorEmail: payload.investigatorEmail,
        // investigatorId: 'alkasjdf', DON'T NEED BECAUSE FIREBASE AUTO GENERATES ID
        icon: 'investigator_on',
        creatorId: getters.user.id
      }
      firebase.database().ref('investigators').push(investigator)
        .then(() => {
          commit('createInvestigator', {
            ...investigator
          })
        })
        .catch((error) => {
          console.log(error)
        })
      // Reach out to firebase and store it
      // commit('createInvestigator', investigator)
    },
    // May have to create a separate Action for each updated item (i.e. updateInvestigatorInvestigator, updateInvestigatorDescription, etc)
    updateInvestigatorData ({commit}, payload) {
      commit('setLoading', true)
      const updateObj = {}
      if (payload.investigatorName) {
        updateObj.investigatorName = payload.investigatorName
      }
      if (payload.investigatorPhone) {
        updateObj.investigatorPhone = payload.investigatorPhone
      }
      if (payload.investigatorEmail) {
        updateObj.investigatorEmail = payload.investigatorEmail
      }
      firebase.database().ref('investigators').child(payload.investigatorId).update(updateObj)
      .then(() => {
        commit('setLoading', false)
        commit('updateInvestigator', payload)
      })
      .catch(error => {
        console.log(error)
        commit('setLoading', false)
      })
    },
    deleteInvestigatorData ({commit}, payload) {
      commit('setLoading', true)
      console.log('Payload: ' + JSON.stringify(payload))
      firebase.database().ref('investigators').child(payload.investigatorId).remove()
      .then(() => {
        commit('setLoading', false)
        commit('deleteInvestigator', payload)
      })
      .catch(error => {
        console.log(error)
        commit('setLoading', false)
      })
    }
  },
  getters: {
    loadedInvestigators (state) {
      return state.loadedInvestigators.sort((investigatorA, investigatorB) => {
        return investigatorA.date > investigatorB.date
      })
    },
    featuredInvestigators (state, getters) {
      return getters.loadedInvestigators.slice(0, 5)
    },
    loadedInvestigator (state) {
      return (someId) => {
        return state.loadedInvestigators.find((investigator) => {
          return investigator.investigatorId === someId
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/investigator/index.js